import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { coreAnimations } from 'app/_shared/animations/core.anitmation';
import { MatMenuTrigger } from '@angular/material/menu';
import { CardChartModel } from './cardChart.model';
import { Enums, IEnums } from '../../app.enums';
import { IOutboundKpisModel, OutboundKpisService } from 'app/_shared/services';
import { FilterService, FilterMonth } from '../shared/filter.service';
import { ReportsService } from '../shared/reports.service';
import * as Models from 'app/_shared/models/models-index';
import { OutboundSummaryMetricsByDay } from '../shared/outboundSummaryMetricsByDay.model';
import { Subscription } from 'rxjs';
import moment from 'moment';

@Component({
    selector: 'dashboard-card-chart',
    templateUrl: './card-chart.component.html',
    styleUrls: ['./card-chart.component.scss'],
    animations: coreAnimations,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardChartComponent implements OnInit {
  @Input() chartInfo: CardChartModel;
  @Input() multiKpi: boolean;
  @Input() summaryMetrics?: OutboundSummaryMetricsByDay;

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  enums: IEnums = Enums;

  selectedKpi: IOutboundKpisModel = null;
  outboundKpis: IOutboundKpisModel[] = null;

  availableDates: FilterMonth[] = [];
  selectedDate: FilterMonth = null;
  filterState: Models.FilterState;
  filterServiceUpdatedSub: Subscription;
  outboundSummaryMetricsByDaySub: Subscription;

  private isInboundRoute: boolean = false;

  constructor(
    private filterService: FilterService,
    private outboundKpisService: OutboundKpisService,
    private currentRoute: ActivatedRoute,
    private reportsService: ReportsService
  ) {
  }

  ngOnInit(): void {
    console.debug('card-chart', this.chartInfo);
    this.currentRoute.parent.url.subscribe((urlPath) => {
      const url = urlPath[urlPath.length - 1].path;
      if (url === this.enums.dashboardSegment.inbound)
        this.isInboundRoute = true;
    });

    if (!this.isInboundRoute) {
      this.filterServiceUpdatedSub = this.filterService.updatedSubject.subscribe(filterState => {
        this.filterState = { ...filterState };
        this.availableDates = this.filterService.getTrendKpiMonths();
        this.selectedDate = this.availableDates.find(d => d.startDate.getTime() === this.filterState.startDate.getTime() && d.endDate.getTime() === this.filterState.endDate.getTime());
      });
      this.outboundKpis = this.outboundKpisService.getKpis();
      this.selectedKpi = this.outboundKpis.find(kpi => kpi.isDefault === true);
    }
    console.debug("card-chart-info", this.chartInfo);
  }

  onKpiSelected(selected: IOutboundKpisModel): void {
    this.selectedKpi = this.outboundKpis.find(kpi => kpi.description === selected.description);
    this.updateGraph(this.summaryMetrics);
  }

  onDateChanged(selected: FilterMonth): void {
    this.selectedDate = this.availableDates.find(d => d.startDate === selected.startDate && d.endDate === selected.endDate);
    this.getUpdatedData();
  }

  private getUpdatedData(): void {
    this.filterState.startDate = this.selectedDate.startDate;
    this.filterState.endDate = this.selectedDate.endDate;

    this.outboundSummaryMetricsByDaySub = this.reportsService.getOutboundSummaryMetricsByDay(this.filterState)
      .subscribe(summaryMetrics => {
        this.summaryMetrics = summaryMetrics;
        this.updateGraph(summaryMetrics);

      });
  }

  private updateGraph(summaryMetrics: OutboundSummaryMetricsByDay): void {
    let data: number[] = [];
    let dateFormat: string = null;

    switch (this.selectedKpi.description) {
      case this.enums.outboundKpis.campaignSize:
        data = summaryMetrics.records.map(r => r.campaignSize);
        break;
      case this.enums.outboundKpis.liveConnections:
        data = summaryMetrics.records.map(r => r.liveConnections);
        break;
      case this.enums.outboundKpis.appointments:
        data = summaryMetrics.records.map(r => r.appointments);
        break;
      case this.enums.outboundKpis.messages:
        data = summaryMetrics.records.map(r => r.voicemails);
        break;
      default:
        data = summaryMetrics.records.map(r => r.campaignSize);
        break;
    }

    switch (this.selectedDate.label) {
      case this.enums.outboundKpiDateType.dashboardTimePeriod:
        dateFormat = 'MM/DD';
        break;
      case this.enums.outboundKpiDateType.last12Months:
        dateFormat = 'MM/YY';
        break;
      default:
        dateFormat = 'MM/YY';
        break;
    }

    console.debug('data', data);
    this.chartInfo.data.datasets[0].data = data;
    this.chartInfo.data.labels = summaryMetrics.records.map(r => moment(r.date).format(dateFormat));
  }
}
